import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import PAN2OutputComponent from '../output/PAN2OutputComponent';

/**
 * PAN Details (V2) — GridLines-backed PAN verification.
 *
 * Routed to from DynamicReportComponent when the report-type slug is
 * `pan-details-v2`. Accepts the same `serviceId` / `serviceDetails` props
 * the other input components take so it integrates with the form-builder
 * verification picker on the Lead Wizard.
 */
const PAN2InputComponent = ({ serviceId, serviceDetails, leadId }) => (
    <SimpleReportForm
        serviceId={serviceId}
        serviceDetails={serviceDetails}
        leadId={leadId}
        banner={{ icon: 'pi-id-card', title: 'PAN Verification (v2)', subtitle: 'Enhanced PAN verification via Gridlines' }}
        fields={[
            { name: 'pan_number', label: 'PAN Number', icon: 'pi-id-card', placeholder: 'ABCDE1234F', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true,
              regex: /^[A-Z]{5}\d{4}[A-Z]$/, regexError: 'Invalid PAN format', colClass: 'col-12 md:col-6 lg:col-4' },
        ]}
        endpoint={{
            path: '/gridlines/pan-details',
            bodyMapper: (v, sid, lid) => ({
                pan_number: v.pan_number,
                consent: 'Y',
                api_provider_service_id: parseInt(sid, 10),
                ...(lid ? { lead_id: parseInt(lid, 10) } : {}),
            }),
        }}
        consentReportType="pan"
        submitLabel="Verify PAN"
        successSummary="PAN verified"
        errorSummary="PAN verification failed"
        confirmHeader="Confirm PAN verification"
        confirmAcceptLabel="Yes, verify"
        // Authenticated blob download, same as DL v2. The old button opened the
        // `pdf_download_url` from the verify response in a new tab — but that URL
        // carries a smart token cached for 24h, so the link died on expiry or on
        // any `cache:clear` while the URL lived on in the DB. window.open also
        // hid the resulting 401, so the app cheerfully reported "Download
        // started" over a tab full of error JSON.
        pdfEndpoint={(reportId) => `/gridlines/pan-v2/${reportId}/download-pdf`}
        pdfPasswordHint='Last 4 digits of your PAN + "PAN" (Example: If PAN is ABCDE1234F, password is 1234PAN)'
        outputComponent={PAN2OutputComponent}
    />
);

export default PAN2InputComponent;
